module.exports = __webpack_public_path__ + "media/images/emblems/Evolene-coat_of_arms-68aae8b1e97208aecb42afde9243c749.png";